<app-side-nav class="side-nav"></app-side-nav>
<div #sectionsContainer class="sections" aria-label="Horizontal Sections">
  <section id="about" class="section"><app-about></app-about></section>
  <section id="why-me" class="section"><app-why-me></app-why-me></section>
  <section id="skills" class="section"><app-skills></app-skills></section>
  <section id="my-work" class="section"><app-my-projects></app-my-projects></section>
  <section id="references" class="section"><app-references></app-references></section>
  <section id="contact" class="section"><app-contact></app-contact></section>
</div>
